import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";

const AssigneesContainer = React.memo(({ className, ...props }) => (
  <div
    {...props}
    className={classNames(styles.assigneesContainer, className)}
    data-testid="assignees-container"
  />
));

AssigneesContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default AssigneesContainer;
